import Cookies from 'js-cookie';
import SubUsersService from "@/services/resources/SubUsersService";
const serviceSubUsers = SubUsersService.build();


export default {

    userSuccess: (state, resp) => {
        state.user = resp;
        localStorage.user = JSON.stringify(resp)
        Cookies.set('user', JSON.stringify(resp), {
            expires: 365
        });
    },
    userClub: (state, resp) => {
        state.userClub = resp;
        Cookies.set('club_integration', JSON.stringify(resp), {
            expires: 365
        });
    },
    verifyEmail: (state, resp) => {
        state.verifyEmail = resp;
        Cookies.set('verify_email', JSON.stringify(resp), {
            expires: 365
        });
    },
    setPanel: (state, resp) => {
        state.setPanel = resp.id;
        Cookies.set('setPanel', resp.id, {
            expires: 7
        });
        localStorage.setItem('subUser', JSON.stringify(resp));
    },
    resetPanel: (state, resp) => {
        state.setPanel = null;
        Cookies.remove('setPanel');
        localStorage.removeItem("subUser");
    },
    adminUserSuccess: (state, resp) => {
        state.user = resp;
    },

    userLogout: async (state) => {
        const locationadm = await localStorage.locationadm;       
        const user = await JSON.parse(localStorage.user);
        if(await user.is_admin) {
            await serviceSubUsers
            .delete('remove-subusers-erp')
            .then(async (response) => {
                console.log('remove-subusers-erp',response);
            })
            .catch(async (err) => {
                await reject(err);
            });
        }
        state.user = null;
        state.permissions = null;
        state.verify_permissions = null;
        state.userClub = null;
        state.verifyEmail = null
        state.setPanel = null
        state.access_token = '';

        Cookies.remove('access_token');
        Cookies.remove("setPanelName");
        Cookies.remove("setPanelPermission");
        Cookies.remove('setPanel');
        Cookies.remove('club_integration');
        Cookies.remove('user');
        Cookies.remove('verify_email');
        Cookies.remove('menuPermissions');
        localStorage.removeItem("subUser");
        sessionStorage.clear();
        localStorage.clear();
        // Obter o primeiro segmento do pathname após o host
        const pathSegments = window.location.pathname.split('/').filter(segment => segment);
        const firstPathSegment = pathSegments.length > 0 ? pathSegments[0] : '';

        if(firstPathSegment !== 'admin-login') {
            localStorage.locationadm = await locationadm;
                window.location.href = window.location.protocol + "//" + window.location.host
        }
    },
}